import React, {useEffect, useState} from 'react';
import VerticalCenteredModal from './VerticalCenteredModal';
import {event, EVENT_TYPES} from '../../utils/event';

function AppModal() {
	const [pcm, showPCM] = useState(false);
	const [unsupported, showUnsupported] = useState(false);
	const [hasPCMContinue, setHasPCMContinue] = useState(true);

	useEffect(() => {
		const pcmCallback = () => {
			showPCM(true);
		};
		const acmCallback = () => {
			setHasPCMContinue(false);
			showPCM(true);
		};

		const videoUnsupportedCallback = () => {
			showUnsupported(true);
		};

		event.on(EVENT_TYPES.PLAYER_PCM_CALLBACK, pcmCallback)
				.on(EVENT_TYPES.PLAYER_ACM_CALLBACK, acmCallback)
				.on(EVENT_TYPES.PLAYER_UNSUPPORTED, videoUnsupportedCallback);

		return () => {
			event.off(EVENT_TYPES.PLAYER_PCM_CALLBACK, pcmCallback)
					.off(EVENT_TYPES.PLAYER_ACM_CALLBACK, acmCallback)
					.off(EVENT_TYPES.PLAYER_UNSUPPORTED, videoUnsupportedCallback);
		};
	}, []);

	return (
			<>
				<VerticalCenteredModal show={pcm}
															 hasCustom={hasPCMContinue}
															 onCustom={() => {
																 event.trigger(EVENT_TYPES.PLAYER_REPLAY);
																 showPCM(false);
															 }}
															 onClose={() => {
																 showPCM(false);
															 }}
															 id="pcm" />
				<VerticalCenteredModal show={unsupported}
															 onClose={() => showUnsupported(false)}
															 id="video_unsupported" />
			</>
	);
}

export default AppModal;
